<template>
  <div>
    <div v-if="crew.id || createMode">
      <customer-edit :crew="crew" :title="title" @saved="updateCrew"></customer-edit>
    </div>
    <div v-else>Elemento no encontrado</div>
  </div>
</template>

<script>
import catalogService from "@/services/catalog";
import CustomerEdit from "./Edit";

export default {
  name: "Update",

  props: {
    id: {
      type: String,
      default: "",
    },
  },

  components: {
    CustomerEdit,
  },

  data() {
    return {
      crew: { id: null },
      createMode: false,
      title: "Editar Cuadrilla",
    };
  },
  mounted() {
    if (this.id !== "nuevo") {
      this.createMode = false;
      catalogService.fetch("crew", this.id).then((crew) => {
        this.crew = crew;
      });
    } else {
      this.title = "Crear Cuadrilla";
      this.createMode = true;
    }
  },
  methods: {
    updateCrew({ original, updated }) {
      if (!original.id) {
        catalogService
          .create("crew", updated)
          .then((crew) => {
            this.$successMessage({ title: `Nuevo Cuadrilla: ${crew.name}` });
            this.crew = crew;
            this.$router.push({ path: `/cuadrillas/${crew.id}` });
          })
          .catch(this.$fireErrorResponse);
      } else {
        catalogService.update("crew", updated, original).then((crew) => {
          this.crew = crew;
          this.$$successMessage({ title: `${crew.name} fue actualizado` });
          this.$router.push({ path: "/cuadrillas" });
        }, this.$fireErrorResponse);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Catalogs/Crews/Update.vue